import { addReplaceAll } from "@/polifills/modules/replaceAll";

export function addPolyfills() {
  addReplaceAll();
}
